<template>
  <v-layout align-center class="primary_dark" mx-0 row wrap>
    <v-flex xs12 sm12 md12>
      <v-img :height="$vuetify.breakpoint.mdAndUp ? '650' : '500'" :src="image"></v-img>
    </v-flex>
  </v-layout>
</template>
<style scoped>
.bg-accent-dark {
  background-color: #f9a61b !important;
}
</style>
<script>
export default {
  props: ["image", "imgleft"],
  data() {
    return {};
  }
};
</script>